import { NgModule } from '@angular/core';
import { RouteService } from '../routing/services/route.service';
import { RoutingModuleContract } from '../support/modules/interfaces/routing-module.interface';
import { RoutingModule } from '../support/modules/routing-module';
import { ChassisDashboardsBootstrapModule } from './dashboards-bootstrap.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CustomWidgetComponent } from './components/custom-widget/custom-widget.component';
import { ActivityStreamWidgetComponent } from './components/activity-stream-widget/activity-stream-widget.component';
import { ListWidgetComponent } from './components/list-widget/list-widget.component';
import { ContainerComponent } from './components/container/container.component';
import { AddWidgetModal } from './modals/add-widget-modal/add-widget.modal';
import { WidgetListModal } from './modals/widget-list-modal/widget-list.modal';
import { TwoColumnLayoutComponent } from './components/two-column-layout/two-column-layout.component';
import { UserListWidgetComponent } from './components/user-list-widget/user-list-widget.component';
import { HandleDirective } from './directives/handle.directive';
import { DashboardPage } from './pages/dashboard/dashboard.page';

@NgModule({
    imports: [
        ChassisDashboardsBootstrapModule,
    ],
    declarations: [
        AddWidgetModal,
        ContainerComponent,
        CustomWidgetComponent,
        DashboardComponent,
        DashboardPage,
        HandleDirective,
        ListWidgetComponent,
        ActivityStreamWidgetComponent,
        TwoColumnLayoutComponent,
        UserListWidgetComponent,
        WidgetListModal
    ],
    entryComponents: [
        AddWidgetModal,
        ContainerComponent,
        CustomWidgetComponent,
        DashboardComponent,
        DashboardPage,
        ListWidgetComponent,
        ActivityStreamWidgetComponent,
        TwoColumnLayoutComponent,
        UserListWidgetComponent,
        WidgetListModal
    ],
    providers: [],
    exports: [
        ContainerComponent,
        CustomWidgetComponent,
        DashboardComponent,
        DashboardPage,
        ListWidgetComponent,
        ActivityStreamWidgetComponent,
        TwoColumnLayoutComponent,
        UserListWidgetComponent
    ],
})
export class ChassisDashboardsRoutingModule extends RoutingModule implements RoutingModuleContract {

    public routes(routes: RouteService) {
        routes.add('', DashboardPage, 'home');
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/dashboards-routing.module.ts